import { create } from "zustand";
import { persist } from "zustand/middleware";

const STORAGE_KEY = "secret-missions-mission-progress";

/**
 * Which of a mission's steps have been ticked, per mission. Persisted so a
 * mission left half done is found half done tomorrow: the point of the
 * steps is that they can come back to them. Cleared for a mission once its
 * report is filed.
 */
interface MissionProgressState {
  done: Record<string, number[]>;
  toggle: (key: string, step: number) => void;
  /** the adventure's chain says where they are: keep the cache in step */
  setDone: (key: string, steps: number[]) => void;
  clear: (key: string) => void;
}

export const useMissionProgress = create<MissionProgressState>()(
  persist(
    (set) => ({
      done: {},
      toggle: (key, step) =>
        set((s) => {
          const current = s.done[key] ?? [];
          const next = current.includes(step)
            ? current.filter((n) => n !== step)
            : [...current, step].sort((a, b) => a - b);
          return { done: { ...s.done, [key]: next } };
        }),
      setDone: (key, steps) =>
        set((s) => {
          const current = s.done[key] ?? [];
          const same =
            current.length === steps.length &&
            current.every((n, i) => n === steps[i]);
          return same ? s : { done: { ...s.done, [key]: [...steps] } };
        }),
      clear: (key) =>
        set((s) => {
          const done = { ...s.done };
          delete done[key];
          return { done };
        }),
    }),
    { name: STORAGE_KEY, version: 1, partialize: (s) => ({ done: s.done }) },
  ),
);
